import { format } from 'date-fns';

/**
 * Utility functions for date manipulation
 */

/**
 * Gets the ISO week number and year for a given date
 * @param {Date|string} dateInput - The date to process
 * @returns {Object} { year: number, week: number }
 */
export const getISOWeekAndYear = (dateInput) => {
  const date = new Date(dateInput);
  const target = new Date(date.valueOf());
  
  // ISO day 0 is Monday
  const dayNr = (date.getDay() + 6) % 7;
  
  // Set to nearest Thursday: current date + 3 - current day number
  target.setDate(target.getDate() + 3 - dayNr);
  
  // Jan 4 is always in week 1
  const firstThursday = target.valueOf();
  target.setMonth(0, 4);
  const jan4 = (target.getDay() + 6) % 7;
  target.setDate(target.getDate() + 3 - jan4);
  
  const week = Math.round((firstThursday - target) / 604800000) + 1;
  
  // The year for the week might be different from the calendar year
  const year = new Date(firstThursday).getFullYear();
  
  return { year, week };
};

/**
 * Formats a date for CQL queries (YYYY-MM-DD HH:mm:ss)
 * @param {Date|string} date - The date to format
 * @returns {string} - Formatted date string
 */
export const formatDateForCql = (date) => {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
};

/**
 * Returns the min and max timestamp for a given date string
 * @param {string} cqlFecha - Date string in format 'YYYY-MM-DD HH:mm:ss'
 * @returns {Object} { min: string, max: string }
 */
export const getDateRange = (cqlFecha) => {
  if (!cqlFecha) return { min: '', max: '' };
  const datePart = cqlFecha.split(' ')[0];
  return {
    min: `${datePart} 00:00:00`,
    max: `${datePart} 23:00:00`
  };
};

/**
 * Combines date and time strings into a single CQL format string
 * @param {string} date - Date string 'YYYY-MM-DD'
 * @param {string} time - Time string 'HH:mm:ss'
 * @returns {string} - Combined string 'YYYY-MM-DD HH:mm:ss'
 */
export const combineDateAndTime = (date, time) => {
  if (!date || !time) return '';
  return `${date} ${time}`;
};
